// extracted by mini-css-extract-plugin
module.exports = {"param":"Parameters_param__Ghd9x","semi":"Parameters_semi__3VGlU","wrap":"Parameters_wrap__23DHQ","column":"Parameters_column__3GvU8","labelWrap":"Parameters_labelWrap__MyPv0"};